import React, { forwardRef } from 'react';

import { useStyles } from './ecp-stores.styles';
import { EcpStore } from '../ecp-store';
import { IEcpStore } from '../../../../rest/ecp-locator';
import { IEcpStoresProps } from './ecp-stores.models';

export const EcpStores = forwardRef<HTMLUListElement, IEcpStoresProps>(
  ({ stores, onStoreSelect, storeCode, onScrollToStore }, ref): JSX.Element => {
    const classes = useStyles();

    return (
      <ul
        ref={ref}
        className={classes.root}
        role="list"
        data-testid="stores-list"
      >
        {stores?.map((store: IEcpStore) => (
          <li
            key={store.code}
            role="listitem"
            className={classes.storeItem}
          >
            <EcpStore
              storeData={store}
              onStoreSelect={onStoreSelect}
              storeCode={storeCode}
              onScrollToStore={onScrollToStore}
              contentPartialStyles={classes.storeContentPartial}
            />
          </li>
        ))}
      </ul>
    );
  },
);
